// ProCogia Theme Utilities
export const PROCOGIA_COLORS = {
  green: '#95c100',
  blue: '#1fb8cc', 
  darkGrey: '#333333',
  lightGrey: '#65676e',
  borderGrey: '#c9cace',
  background: '#ffffff',
  white: '#ffffff',
  black: '#000000'
};

// Button styles
export const getButtonStyles = (variant = 'primary') => {
  const baseStyles = {
    padding: '0.5rem 1rem',
    borderRadius: '0.375rem',
    fontWeight: '500',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    textDecoration: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  switch (variant) {
    case 'primary':
      return {
        ...baseStyles,
        backgroundColor: PROCOGIA_COLORS.green,
        color: PROCOGIA_COLORS.white,
        border: `1px solid ${PROCOGIA_COLORS.green}`
      };
    case 'secondary':
      return {
        ...baseStyles,
        backgroundColor: PROCOGIA_COLORS.blue,
        color: PROCOGIA_COLORS.white,
        border: `1px solid ${PROCOGIA_COLORS.blue}`
      };
    case 'outline':
      return {
        ...baseStyles,
        backgroundColor: 'transparent',
        color: PROCOGIA_COLORS.green,
        border: `1px solid ${PROCOGIA_COLORS.green}`
      };
    default:
      return baseStyles;
  }
};

// Card styles
export const getCardStyles = () => ({
  backgroundColor: PROCOGIA_COLORS.white,
  border: `1px solid ${PROCOGIA_COLORS.borderGrey}`,
  borderRadius: '0.5rem',
  boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)'
});

// Text styles
export const getTextStyles = (variant = 'body') => {
  switch (variant) {
    case 'heading':
      return { color: PROCOGIA_COLORS.darkGrey, fontWeight: '600' };
    case 'subheading':
      return { color: PROCOGIA_COLORS.darkGrey, fontWeight: '500' };
    case 'body':
      return { color: PROCOGIA_COLORS.darkGrey };
    case 'muted':
      return { color: PROCOGIA_COLORS.lightGrey };
    case 'success':
      return { color: PROCOGIA_COLORS.green };
    case 'info':
      return { color: PROCOGIA_COLORS.blue };
    default:
      return { color: PROCOGIA_COLORS.darkGrey };
  }
};

// Input styles
export const getInputStyles = () => ({
  backgroundColor: PROCOGIA_COLORS.white,
  border: `1px solid ${PROCOGIA_COLORS.borderGrey}`,
  borderRadius: '0.375rem',
  padding: '0.5rem 0.75rem',
  color: PROCOGIA_COLORS.darkGrey,
  fontSize: '0.875rem'
});

// Status badge styles
export const getBadgeStyles = (status) => {
  const baseStyles = {
    padding: '0.25rem 0.5rem',
    borderRadius: '0.25rem',
    fontSize: '0.75rem',
    fontWeight: '500',
    textTransform: 'uppercase',
    letterSpacing: '0.025em'
  };

  switch (status?.toLowerCase()) {
    case 'active':
    case 'operational':
    case 'online':
    case 'success':
      return {
        ...baseStyles,
        backgroundColor: '#e8f5e8',
        color: PROCOGIA_COLORS.green
      };
    case 'warning':
    case 'maintenance':
    case 'scheduled':
      return {
        ...baseStyles,
        backgroundColor: '#e6f7fa',
        color: PROCOGIA_COLORS.blue
      };
    case 'critical':
    case 'error':
    case 'offline':
    case 'failed':
      return {
        ...baseStyles,
        backgroundColor: '#e6f7fa',
        color: PROCOGIA_COLORS.blue
      };
    default:
      return {
        ...baseStyles,
        backgroundColor: '#f1f5f9',
        color: PROCOGIA_COLORS.lightGrey
      };
  }
};

// Icon color helper
export const getIconColor = (type) => {
  switch (type) {
    case 'success':
    case 'active':
      return PROCOGIA_COLORS.green;
    case 'info':
    case 'warning':
      return PROCOGIA_COLORS.blue;
    case 'error':
    case 'critical':
      return PROCOGIA_COLORS.blue;
    default:
      return PROCOGIA_COLORS.lightGrey;
  }
};

// Hover effects
export const addHoverEffect = (element, variant = 'primary') => {
  if (!element) return;
  
  const originalBg = element.style.backgroundColor;
  const originalColor = element.style.color;
  
  element.addEventListener('mouseenter', () => {
    switch (variant) {
      case 'primary':
        element.style.backgroundColor = PROCOGIA_COLORS.blue;
        break;
      case 'secondary':
        element.style.backgroundColor = PROCOGIA_COLORS.darkGrey;
        break;
             default:
         element.style.backgroundColor = '#f8f9fa';
         element.style.color = PROCOGIA_COLORS.darkGrey;
    }
  });
  
  element.addEventListener('mouseleave', () => {
    element.style.backgroundColor = originalBg;
    element.style.color = originalColor;
  });
}; 